import { Checkbox } from "@mui/material";
import type { ICellRendererParams } from "ag-grid-community";
import React from "react";

export const CheckboxRenderer = (params: ICellRendererParams) => {
	return <Checkbox checked={Boolean(params.value)} disabled color="primary" />;
};
